/* eslint-disable @atlassian/i18n/enforce-id-by-package -- Preserve existing translations when moving AI Inbox presentation into SessionList. */

import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'sessionListLabel'
	| 'sessionTitle'
	| 'openSessionLabel'
	| 'openSessionWorkingLabel'
	| 'openSessionNeedsInputLabel';

// Keep the existing AI Inbox translation IDs as presentation moves into this shared owner.
const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		sessionListLabel: {
			id: 'ai-inbox.sessionListLabel',
			defaultMessage: 'Agent sessions',
			description: 'Accessible label for a list of agent sessions.',
		},
		sessionTitle: {
			id: 'ai-inbox.sessionTitle',
			defaultMessage: 'Agent session',
			description: 'Neutral fallback title for an agent session without a session title.',
		},
		openSessionLabel: {
			id: 'ai-inbox.openSessionLabel',
			defaultMessage: 'Open session: {title}',
			description: 'Accessible label for the button that opens an agent session conversation.',
		},
		openSessionWorkingLabel: {
			id: 'rovo-platform-ui-components.session-list.openSessionWorkingLabel',
			defaultMessage: 'Open session: {title}, working',
			description: 'Accessible label for a button that opens a working agent session.',
		},
		openSessionNeedsInputLabel: {
			id: 'ai-inbox.openSessionNeedsInputLabel',
			defaultMessage: 'Open session: {title}, needs input',
			description:
				'Accessible label for a button that opens an agent session requiring user input.',
		},
	});

export default messages;
